import React from 'react'
import { Loader } from '../loader/loader'


export const FetchingDiv = ({children, isFetching, ...props}) => {
	return (
		<div {...props}>
			{isFetching ? <Loader/> : children}
		</div>
	)
}
